import { useTreasureApi, ApiKeys } from 'hooks/api/use-treasure-api';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import { ReactQueryKeys } from 'enums';

export const useRemoveTeamMember = (): UseMutationResult<
  void,
  unknown,
  { memberId: string }
> => {
  const queryClient = useQueryClient();
  const { treasureApi } = useTreasureApi(ApiKeys.PortalGateway);

  const removeTeamMember = async ({ memberId }: { memberId: string }) => {
    await treasureApi().delete(`/users/${memberId}`);
  };

  return useMutation(removeTeamMember, {
    onSuccess: () => {
      queryClient.refetchQueries(ReactQueryKeys.BusinessMembers);
      queryClient.refetchQueries(ReactQueryKeys.ApprovalPolicy);
    },
  });
};
